import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@mui/material'

const MarkignLegend = ({ marking }) => {
  return (
    <>
      {marking.map((item, index) => (
        <Box key={index} className='flex gap-2 items-center justify-start px-2 py-2 '>
          <FontAwesomeIcon
            icon={['fas', 'circle']}
            size='lg'
            style={{ color: item.color, marginRight: '0.5rem' }}
          />
          <span>{item.name}</span>
        </Box>
      ))}
    </>
  )
}

export default MarkignLegend
